import { BevPageTypes } from '../BevPageTypes';
import { convertToNumber, getConvertedWH } from './generalHelpers';
import { navigate } from 'gatsby';
import { ZOOM_RANGE } from '../constants/generalConstants';
import { round } from './generalHelpers';

const {
  min: ZOOM_MIN_VALUE,
  max: ZOOM_MAX_VALUE,
  precision: ZOOM_PRECISION,
  increment: ZOOM_INC_VALUE,
  decrement: ZOOM_DEC_VALUE,
} = ZOOM_RANGE;

export const defaultUnitIndex = (
  unitList: BevPageTypes.TUnit[],
  selectedUnit: BevPageTypes.TUnit
) => {
  return unitList.findIndex(unit => unit.id === selectedUnit.id);
};

export const scrollToAlignment = (isInitialRender: boolean) =>
  isInitialRender ? 'center' : 'auto';

export const cellCoordinatesGetter = (
  singleUnit: BevPageTypes.TUnit,
  isFacilityMigrated: boolean = false
) => {
  const {
    bev: { x = 0, y = 0, width: bevWidth = 0, depth: bevHeight = 0 } = {},
  } = singleUnit;
  const { width, height } = getConvertedWH(
    bevWidth,
    bevHeight,
    isFacilityMigrated
  );
  return {
    height: convertToNumber(height),
    width: convertToNumber(width),
    x: convertToNumber(x),
    y: convertToNumber(y),
  };
};

export const getDefaultUnit = (
  units: BevPageTypes.TUnit[],
  unit_type_id: string | number
) => {
  const selectedUnitType = units.filter(
    unit =>
      unit.unit_type.id === unit_type_id && unit.rental_status === 'Vacant'
  );
  return selectedUnitType[0];
};

export const getUnitTypeIdArray = (
  unitTypeIdsList: BevPageTypes.TUnitTypeIDList[]
) => {
  return unitTypeIdsList.map(({ id, value: { tfw: { description } } }) => ({
    unit_type_id: id,
    description: description,
  }));
};

export const goToNextStep = (nextRoute: string, navigationStateProps: any) => {
  navigate(nextRoute, {
    state: navigationStateProps,
  });
};

export const getUrl = (url: string) => {
  const urlArr = url.split('/');
  urlArr.pop();
  return urlArr.join('/');
};

export const changeZoomHandler = (
  action: string,
  zoomValue: number,
  setZoomValue: any
) => {
  if (action === 'Increase' && zoomValue <= ZOOM_MAX_VALUE) {
    setZoomValue(Number(round(zoomValue, ZOOM_PRECISION)) + ZOOM_INC_VALUE);
  } else if (action === 'Decrease' && zoomValue > ZOOM_MIN_VALUE) {
    setZoomValue(Number(round(zoomValue, ZOOM_PRECISION)) - ZOOM_DEC_VALUE);
  }
};
